import React from 'react';
import './Snackbar.css';

export function Snackbar({ open, autoHideDuration = 3000, onClose, message, action }) {
  const [visible, setVisible] = React.useState(false);
  const [animating, setAnimating] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      // Show and animate in
      setVisible(true);
      // Small delay to ensure the element is in DOM before animating
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setAnimating(true);
        });
      });

      // Auto-hide timer
      if (autoHideDuration) {
        const t = setTimeout(() => {
          handleClose();
        }, autoHideDuration);
        return () => clearTimeout(t);
      }
    }
    // handleClose is recreated each render; including it would
    // restart the auto-hide timer on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, autoHideDuration]);

  const handleClose = () => {
    // Animate out
    setAnimating(false);
    // Wait for animation to complete before hiding
    setTimeout(() => {
      setVisible(false);
      onClose && onClose();
    }, 200); // Match CSS transition duration
  };

  if (!visible) return null;

  return (
    <div
      className={`snackbar ${animating ? 'snackbar--visible' : ''}`}
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        left: 'var(--space-7)',
        bottom: 'var(--space-5)',
        zIndex: 9999,
        maxWidth: 'min(92vw, 520px)',
        background: 'var(--bg-secondary)',
        border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--radius-control)',
        color: 'var(--text-primary)',
        padding: '10px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        boxShadow: 'var(--shadow-lg)',
      }}
    >
      <span style={{ fontSize: 'var(--text-body-size)' }}>{message}</span>
      <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
        {action}
        <button
          onClick={handleClose}
          className="secondary-button"
          style={{ padding: '6px 8px' }}
          aria-label="Close notification"
          type="button"
        >
          Close
        </button>
      </div>
    </div>
  );
}
